import { render, staticRenderFns } from "./AddressPicturesUploadDialog.vue?vue&type=template&id=bf24ba16&"
import script from "./AddressPicturesUploadDialog.vue?vue&type=script&lang=js&"
export * from "./AddressPicturesUploadDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports